/**
 * @generated SignedSource<<636747788ccd7d965859595f0c93a946>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceTodoEditScheduledArchiveAtArchiveMutation$variables = {
  workspaceTodoId: string;
};
export type WorkspaceTodoEditScheduledArchiveAtArchiveMutation$data = {
  readonly todoWorkspace: {
    readonly archive: {
      readonly archivedAtDate: {
        readonly " $fragmentSpreads": FragmentRefs<"FormattedDate">;
      } | null;
      readonly id: string;
    };
  };
};
export type WorkspaceTodoEditScheduledArchiveAtArchiveMutation = {
  response: WorkspaceTodoEditScheduledArchiveAtArchiveMutation$data;
  variables: WorkspaceTodoEditScheduledArchiveAtArchiveMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "workspaceTodoId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "workspaceTodoId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceTodoEditScheduledArchiveAtArchiveMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TodoWorkspaceMutation",
        "kind": "LinkedField",
        "name": "todoWorkspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TodoWorkspace",
            "kind": "LinkedField",
            "name": "archive",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UnzonedDate",
                "kind": "LinkedField",
                "name": "archivedAtDate",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "FormattedDate"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WorkspaceTodoEditScheduledArchiveAtArchiveMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TodoWorkspaceMutation",
        "kind": "LinkedField",
        "name": "todoWorkspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TodoWorkspace",
            "kind": "LinkedField",
            "name": "archive",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UnzonedDate",
                "kind": "LinkedField",
                "name": "archivedAtDate",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isoString",
                        "storageKey": null
                      }
                    ],
                    "type": "Date",
                    "abstractKey": "__isDate"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "97f9345618bb10296738f2ae5219ac5e",
    "id": null,
    "metadata": {},
    "name": "WorkspaceTodoEditScheduledArchiveAtArchiveMutation",
    "operationKind": "mutation",
    "text": "mutation WorkspaceTodoEditScheduledArchiveAtArchiveMutation(\n  $workspaceTodoId: ID!\n) {\n  todoWorkspace(id: $workspaceTodoId) {\n    archive {\n      id\n      archivedAtDate {\n        ...FormattedDate\n      }\n    }\n  }\n}\n\nfragment FormattedDate on Date {\n  __isDate: __typename\n  ...useFormattedDate\n}\n\nfragment useFormattedDate on Date {\n  __isDate: __typename\n  isoString\n}\n"
  }
};
})();

(node as any).hash = "4a24ee549e8c2bf32efeabea8c3102ec";

export default node;
